import { State } from '../cmsPage.widget'
import { collapseMenuItems } from '../header/siteHeader/cmsSiteHeader.widget'

export type SearchBarProps = {
  setShow: (_: boolean) => void
  updateSearchValue: (newValue: string) => void
  submitSearchValue?: () => void
} & SearchBarState

export type SearchBarState = {
  show: boolean
  searchValue: string
}

export type SearchButtonProps = {
  display: 'mobile' | 'desktop'
  show: boolean
  setShow: (_: boolean) => void
}

// TODO create searchBarStateUpdaters for below
export const setShowToState = (show: boolean) => (state: State) => {
  let s1 = {
    ...state,
    CMSHeaderState: { ...state.CMSHeaderState, searchState: { ...state.CMSHeaderState.searchState, show } },
  }
  if (show && s1.CMSHeaderState.mainMenuItems.kind == 'loaded') {
    s1 = collapseMenuItems(s1, s1.CMSHeaderState.mainMenuItems.value)
  }
  return s1
}

export const setSearchValueToState = (searchValue: string) => (state: State) => ({
  ...state,
  CMSHeaderState: { ...state.CMSHeaderState, searchState: { ...state.CMSHeaderState.searchState, searchValue } },
})

export type SearchFormProps = Pick<SearchBarProps, 'searchValue' | 'updateSearchValue' | "submitSearchValue"> & {
  label: string
  show: boolean
}

export const getSearchQueryFromUrl = () => {
  let params = new URL(window.location.href).searchParams
  let searchQuery = params.get('searchQuery')
  return searchQuery || ''
}

export const searchBarStateZero = (): SearchBarState => ({ show: false, searchValue: getSearchQueryFromUrl() })

export function closeSearchBar(s1: State): State {
  return {
    ...s1,
    CMSHeaderState: { ...s1.CMSHeaderState, searchState: { ...s1.CMSHeaderState.searchState, show: false } },
  }
}
